import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RoleType } from 'src/app/modules/auth/enums/RoleType';
import { RoleUtils } from 'src/app/modules/auth/helpers/role.utils';
import { UserModel } from 'src/app/modules/auth/models/user.model';
import { PageableModel } from '../../models/pageable.model';
import { CrudService } from '../../services/crud.service';
import { ArrayUtils } from '../../utils/array.utils';

@Component({
  selector: 'app-singletilepicker',
  templateUrl: './singletilepicker.component.html',
  styleUrls: ['./singletilepicker.component.scss']
})
export class SingletilepickerComponent implements OnInit {
  @Input() model!: any;
  @Input() entity!: string;
  @Input() choices!: any; // Use Enums
  @Input() name!: string;
  @Input() multiple = false;
  @Input() placeholder!: string;
  @Input() field = 'nome';
  @Input() freeText = false;
  @Input() codeField = 'id';
  @Input() sortField = 'created.desc';
  @Input() excludedField = new Array<string>();
  @Input() included = new Array<any>();
  @Input() includeField = '';
  @Input() filters = {};
  @Input() removeDuplicates = true;
  @Input() alwaysInclude = new Array<any>();
  @Output() modelChange = new EventEmitter<any>();
  @Output() modelChangeComplete = new EventEmitter<any>();

  list: any[] = new Array<any>();

  filtered!: any[];

  constructor(private crudService: CrudService<any>) { }

  ngOnInit(): void {
    if (this.entity) {
      this.crudService.getPage(this.entity, 0, 100, this.sortField, this.filters)
        // tslint:disable-next-line: deprecation
        .subscribe(
          (items: PageableModel<any>) => {
            if (this.excludedField.length > 0) {
              items.content = items.content.filter(c => this.excludedField.findIndex(d => d === c[this.codeField]) === -1);
            }

            if (this.included.length > 0) {
              items.content = items.content.filter(
                (i: any) => {
                  return this.included.indexOf(
                    this.includeField.split('.').reduce((a: any, b: any) => typeof a === 'object' ? a[b] : a, i)) > -1
                    || this.checkRole(i, RoleType.ADMIN);
                });
            }

            if (this.removeDuplicates) {
              items.content = items.content.filter((value, index, self) =>
                index === self.findIndex((t) => {
                  if (value.riferimento) {
                    return t.riferimento.trim() === value.riferimento.trim()
                  }
                  return t.riferimento
                }
                )
              )
            }

            this.list = items.content;

            if (this.model && this.model.map) {
              this.model = this.model.map(
                (x: any) => typeof x === 'string' ? ({ name: this.list.find(d => d[this.codeField] === x)[this.field], code: x }) :
                  ({ name: this.list.find(d => d[this.codeField] === x[this.codeField])[this.field], code: x[this.codeField] }));

            }
          },
          error => {

          },
          () => {
          });
    }
    else {
      this.list = ArrayUtils.enumToArray(this.choices);
    }

  }

  checkRole(user: UserModel, role: RoleType): boolean {
    return RoleUtils.checkRole(user?.roles, role);
  }

  filter(event: any): void {
    this.filtered = this.list.filter(i => i[this.field as keyof typeof i].toLowerCase().indexOf(event.query.toLowerCase()) === 0).map(i =>
      ({ name: i[this.field as keyof typeof i], code: i.id }));
  }

  eventChange(selected: any): void {
    let output = selected;
    if (this.model.map) {
      output = this.model.map((c: any) => ({ name: c.name, code: this.list.find(d => d[this.field] === c.name)[this.codeField] }));
    }

    this.modelChange.emit(output);
    this.modelChangeComplete.emit(output[this.codeField]);
  }

  onBlur(event: any) {
    if (this.list.findIndex(i => i[this.codeField] == event.srcElement.value) == -1 && event.srcElement.value.length > 0 && this.freeText) {
      this.list.push({ id: event.srcElement.value, [this.field]: event.srcElement.value })
    }
    this.modelChange.emit({ name: event.srcElement.value, id: event.srcElement.value });
    this.modelChangeComplete.emit({ name: event.srcElement.value, id: event.srcElement.value });
  }

}
